import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbMomentDateModule, NbMomentDateService } from '@nebular/moment';
import { NbActionsModule, NbCardModule, NbDatepickerModule } from '@nebular/theme';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { PipesModule } from '../../../shared/pipes/pipes.module';
import { SharedModule } from '../../../shared/shared.module';
import { DashboardComunicationService } from '../../dashboard/dashboard/dashboard-comunication.service';
import { MarketingComunicationService } from '../../metrics/marketing/marketing-comunication.service';
import { SalesComunicationService } from '../../metrics/sales/sales-comunication.service';
import { AutocompleteModule } from '../autocomplete/autocomplete.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { DropDownService } from '../dropdown/dropdown.service';
import { AssignmentRulesComunicationService } from './../../../pages/profile/assignment-rules-comunication.service';
import { AssignmentRulesProfileFiltersComponent } from './assignment-rules-profile-filters/assignment-rules-profile-filters.component';
import { DashboardFilterComponent } from './dashboard-filter/dashboard-filter.component';
import { LeadsFilterComponent } from './leads-filter/leads-filter.component';
import { NewDashboardFilterComponent } from './new-dashboard-filter/new-dashboard-filter.component';

@NgModule({
  declarations: [LeadsFilterComponent,
                 DashboardFilterComponent,
                 NewDashboardFilterComponent,
                 AssignmentRulesProfileFiltersComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule.forChild(),
    NgbModule,
    NgxDatatableModule,
    NbCardModule,
    NbActionsModule,
    NbMomentDateModule,
    NbDatepickerModule,
    FormsModule,
    NgxDaterangepickerMd,
    NgxIntlTelInputModule,
    PipesModule,
    DropdownModule,
    AutocompleteModule,
  ],
  exports: [LeadsFilterComponent,
            DashboardFilterComponent,
            NewDashboardFilterComponent,
            NgbAccordionModule,
            AssignmentRulesProfileFiltersComponent,
  ],
  providers: [
    NbMomentDateService,
    DropDownService,
    MarketingComunicationService,
    SalesComunicationService,
    DashboardComunicationService,
    AssignmentRulesComunicationService,
  ]
})
export class FiltersModule { }
